'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { classNames } from '@/util/utils';
import styles from './category-button.module.css';
interface CategoryButtonProps {
  className?: string;
  selected?: boolean;
  disabled?: boolean;
  onClick?(): void;
  children: string;
}
export default function CategoryButton(t0) {
  const $ = _c(8);
  const {
    className,
    selected: t1,
    disabled: t2,
    onClick,
    children
  } = t0;
  const selected = t1 === undefined ? false : t1;
  const disabled = t2 === undefined ? false : t2;
  const t3 = selected && styles.selected;
  let t4;
  if ($[0] !== className || $[1] !== t3) {
    t4 = classNames(className, styles.categoryButton, t3);
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children || $[4] !== disabled || $[5] !== onClick || $[6] !== t4) {
    t5 = <button className={t4} disabled={disabled} type="button" onClick={onClick}>{children}</button>;
    $[3] = children;
    $[4] = disabled;
    $[5] = onClick;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}